export default __webpack_public_path__ + "static/media/279196978_2896363167330630_3555778772222612934_n.cc871f27.jpg";